import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, signal, TemplateRef, ViewChild, WritableSignal } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MFAConstants } from 'countable@helpers';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { finalize, map, tap } from 'rxjs/operators';
import { AuthStateModel, EmailModel, TwoFactorResponseModel } from 'src/app/model/two-factor.model';
import { UserModel } from 'src/app/model/user.model';
import { AclService } from 'src/app/services/acl.service';
import { AuthService } from 'src/app/services/auth.service';
import { MfaService } from 'src/app/services/mfa.service';
import { SharedService } from '../../shared/shared.service';
import { SPIN_STYLES, SpinInputModel } from 'countable@model';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { SpinDirective } from '../../../directives/spin.directive';
import { QRCodeComponent } from 'angularx-qrcode';
import { ClipboardModule } from '@angular/cdk/clipboard';


@Component({
  selector: 'app-privacy-security',
  templateUrl: './privacy-security.component.html',
  styleUrls: ['./privacy-security.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatDialogModule,MatFormFieldModule, ToastrModule, ClipboardModule,
    MatInputModule, MatTabsModule, MatRadioModule, MatIconModule,   MatSlideToggleModule, MatExpansionModule, SpinDirective, QRCodeComponent ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacySecurityComponent implements OnInit, OnDestroy {
  @ViewChild('MFADialog') MFADialog: TemplateRef<any>;
  public tabIndex: number = 3;
  public userDetails: UserModel = null;
  public otpNumber: string = '';
  public mfaStatus: AuthStateModel = new AuthStateModel();
  public googleAuth: TwoFactorResponseModel | null | string = new TwoFactorResponseModel()
  public mfaData: TwoFactorResponseModel | null = new TwoFactorResponseModel();
  public isEnabled = new UntypedFormControl();
  public otpForm: UntypedFormGroup;
  public isValidOtp: boolean = false;
  public readonly mfaConstants: typeof MFAConstants = MFAConstants;
  public userAuthenticatorlist: any = [];
  public isAccessTypeSuperAdmin: Observable<boolean> = this.aclService.subject.pipe(map((acl) => acl.isSuperAdmin));
  public ResetMFADialog: 1 | 2 | 3 | 4 | 0 = 0; // 1 = Enable/Disable //2 = 'ResetMFA' // 3 = 'disableMfa'
  public isToggleStatus: boolean = false;
  public isWrongOtp: boolean = false;
  public emailOTPStatus: EmailModel = new EmailModel();
  public resendTimer: number;
  private resendTimerSub: Subscription = new Subscription();
  public isFirmMandatoryMfa: boolean = false;
  public isMfaEnabledForUser: boolean = false;
  public showWarning: Observable<boolean>;
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null, SPIN_STYLES.BLUR_WITH_SPIN, false));
  private spinCount: number = 0;

  constructor(private dialog: MatDialog, private mfaService: MfaService, private authService: AuthService, private toaster: ToastrService,
    private fb: UntypedFormBuilder, private aclService: AclService, private sharedservice: SharedService) { }

  ngOnInit(): void {
    this.showWarning = this.sharedservice.mandatorymfa.asObservable();
    this.userDetails = this.authService.getUser();
    this.createOtpForm();
    this.getUserAuthList();
  }

  createOtpForm() {
    this.otpForm = this.fb.group({
      'otpNumber': new UntypedFormControl(''),
      'wrongOtp': new UntypedFormControl(false)
    })
  }

  mfaDialogBox(from: "Enable/Disable" | 'ResetMFA' | 'disableMfa' | 'enableMfa') {
    this.ResetMFADialog = 0;
    const dialogRef = this.dialog.open(this.MFADialog, { disableClose: true });
    dialogRef.afterOpened().subscribe(r => {
      switch (from) {
        case "Enable/Disable":
          this.ResetMFADialog = 1;
          console.log("isEnabled", this.isEnabled.value);
          break;
        case "ResetMFA":
          this.ResetMFADialog = 2;
          break;
        case ("disableMfa"):
          this.ResetMFADialog = 3;
          break;
        case ("enableMfa"):
          this.ResetMFADialog = 4;
          break;
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (from) {
          case "Enable/Disable":
            this.enableDisableMFAForfirm();
            break;
          case "ResetMFA":
            this.ResetMFA();
            break;
          case ('disableMfa'):
            console.log('DisableMFA');
            this.disableMfa(false);
            break;
          case ('enableMfa'):
            console.log('Enable-MFA-DIALOG-OPEN');
            this.disableMfa(true);
            break;
        }
      } else {
        if (from === 'disableMfa') {
          this.mfaStatus.isToggleStatus = true;
        }
        if (from === 'enableMfa') {
          this.mfaStatus.isToggleStatus = false;
        }
      }
      this.ResetMFADialog = 0;
    });
  }

  changeAuthentication(event?: MatTabChangeEvent) {
    this.tabIndex = +event;
    console.log('TabIndex', this.tabIndex, event);
    this.emailOTPStatus = new EmailModel();
    console.log('Email-Otp', this.emailOTPStatus);
    this.otpForm.reset();
    this.mfaService.resetTimer();
    this.resendTimerSub.unsubscribe();
    this.resendTimer = -1;
    switch (this.tabIndex) {
      case (0):
        this.getGoogleAuthentication();
        break;
      case (1):
        this.tabIndex = 1;
        break;
    }
  }

  verifyOTP(event) {
    const otp = event.target.value.replace(/[^0-9]/g, '');
    if (otp.length <= 6) {
      console.log('COREECT-OTP-NUMBER', otp);
      this.otpForm.patchValue({ 'otpNumber': otp });
      this.isValidOtp = otp.length === 6 && this.otpForm.get('otpNumber').valid;
      console.log('this.isValidOtp', this.isValidOtp);
    }
  }

  getGoogleAuthentication() {
    if (typeof this.googleAuth === "object" && this.googleAuth.type === 'GOOGLE_AUTHENTICATOR') {
      console.log('Return-Statement');
      return;
    }
    this.updateSpinnerConfig(true);
    this.mfaService.fetchGoogleAuthenticationStatus().pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      console.log('Google-Response', response);
      if (response.success) {
        this.googleAuth = response ? response.message : null;
        console.log('GoogleAUTHDATA', this.googleAuth);
      } else if (!response.success) {
        this.getGoogleAuthDetails();
      }
    });
  }

  getGoogleAuthDetails() {
    this.mfaService.fetchGoogleAuthenticationDetails().subscribe(response => {
      console.log('Google-Auth-Details-Reposne', response);
      this.googleAuth = response ? { ...response } : null;
    })
  }

  getEmailAuthentication() {
    this.updateSpinnerConfig(true);
    this.mfaService.fetchEmailAuthentication().pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: response => {
        console.log('Email-Response', response);
        if (response.success) {
          // this.emailOTPStatus.isSend = false;
          // this.emailOTPStatus.disableResend = true;
          // this.emailOTPStatus.isResend = true;
          // this.emailOTPStatus.text = 'Resend Code';
          console.log('emailOTPStatus', this.emailOTPStatus);
          this.resendEmailOtp();
        }
      }
    });
  }

  resendEmailOtp() {
    this.resendTimerSub = this.mfaService.resendCodeTimer().subscribe({
      next: (resp) => {
        this.resendTimer = resp;
        resp && (this.emailOTPStatus = { ...this.setEmailOtpModel(true) });
      },
      error: (err) => console.log(err),
      complete: () => {
        this.emailOTPStatus = { ...this.setEmailOtpModel(false) }
        this.resendTimerSub.unsubscribe();
      }
    })
  }

  setEmailOtpModel(isDisable: boolean): EmailModel {
    const status = new EmailModel();
    status.text = 'Resend Code';
    status.isSend = false;
    status.isResend = true;
    status.disableResend = isDisable;
    return status;
  }

  setupAuthentication(type: 'google' | 'email') {
    const otp = this.otpForm.get('otpNumber').value;
    switch (type) {
      case ('google'):
        this.getGoogleOtpVerification(otp);
        break;
      case ('email'):
        this.mfaService.resetTimer();
        this.getEmailOtpVerification(otp);
        break;
    }

  }

  getGoogleOtpVerification(code: number) {
    this.updateSpinnerConfig(true);
    this.mfaService.fetchGoogleOtpStatus(code).pipe(
      tap(resp => {
        this.otpForm.reset();
        if (resp === true) {
          this.getUserAuthList();
          this.toaster.success(this.mfaConstants.MFA_SUCCESS);
        } else {
          this.otpForm.patchValue({ 'wrongOtp': true })
        }
      }),
      finalize(() => this.updateSpinnerConfig(false))
    ).subscribe(response => {

    }).add(() => {
      this.isValidOtp = false;
    })
  }

  getEmailOtpVerification(code: number) {
    this.updateSpinnerConfig(true);
    this.mfaService.fetchEmailOtpStatus(code).pipe(
      tap(resp => {
        this.resendTimerSub.unsubscribe();
        this.otpForm.reset();
        if (resp.success && resp.success === true) {
          console.log('INSIDE-TAP-RESPONSE', resp);
          this.getUserAuthList();
          this.toaster.success(this.mfaConstants.MFA_SUCCESS);
        }
        if (resp && resp.success === false) {
          this.otpForm.patchValue({ 'wrongOtp': true })
        }
      }),
      finalize(() => this.updateSpinnerConfig(false))
    ).subscribe(response => {

    }).add(() => {
      this.isValidOtp = false;
    })
  }

  enableDisableMFAForfirm() {
    this.updateSpinnerConfig(true);
    this.mfaService.EnableDisableMFAbySuperAdmin(this.isEnabled.value).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      console.log(response)
      if (response.success) {
        this.getUserAuthList();
        if (this.isEnabled.value == true) {
          this.toaster.success(this.mfaConstants.ENABLE_SUCCESS);
        } else if (this.isEnabled.value == false) {
          this.toaster.error(this.mfaConstants.DISABLE_SUCCESS);
        }
      }
      console.log('Response of Enable/Disable MFA by Super Admin', response)
    }, error => {
      this.toaster.error(error.error);
      console.log('Error of Enable/Disable MFA by Super Admin', error.error);
    });
  }

  getUserAuthList(isResetMfa?: boolean) {
    this.updateSpinnerConfig(true);
    this.mfaService.FetchAuthList().pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      this.userAuthenticatorlist = response;
      console.log('userAuthenticatorlist', this.userAuthenticatorlist);
      this.userAuthenticatorlist.forEach(e => {
        if (e.hasOwnProperty('firmUserAccountId') && e.hasOwnProperty('isMfaEnabled')) {
          this.isEnabled.setValue(e.isMfaEnabled);
          console.log("isEnabled", this.isEnabled);
        }
        if (e.hasOwnProperty('type') && e.hasOwnProperty('isActive')) {
          console.log('NO MFA SETUP TILL NOW');
          this.mfaStatus.isToggleStatus = false;
          this.mfaStatus.isToggleDisable = false;
          this.mfaStatus.isAuthEnabled = false;
          console.log('NO MFA SETUP TILL NOW - AuthStatus', this.mfaStatus);
        }
        if ((e.hasOwnProperty('isFirmMandatoryMfa') && e.hasOwnProperty('isFirmMandatoryMfa')) && (Object.keys(e).length === 2)) {
          this.isFirmMandatoryMfa = e.isFirmMandatoryMfa;
          this.isMfaEnabledForUser = e.isMfaEnabledForUser;
          this.sharedservice.mandatorymfa.next(this.isFirmMandatoryMfa);
        }
      });
      const Obj = this.userAuthenticatorlist.filter(m => (m.type === "GOOGLE_AUTHENTICATOR" || m.type === "EMAIL"));
      const mfaObject: TwoFactorResponseModel = Obj[0] ? Obj[0] : Obj;
      if (mfaObject && mfaObject.isActive) {
        this.mfaStatus.isAuthType = mfaObject.type;
        this.mfaStatus.isAuthEnabled = true;
        this.mfaStatus.isToggleStatus = this.isMfaEnabledForUser === true;
        this.mfaStatus.isToggleDisable = mfaObject.isFirmMandatoryMfa;
        this.mfaStatus.showAuthName = this.mfaService.getAuthDisplayName(mfaObject.type);
        console.log('AuthStatus-Inside-If', this.mfaStatus);
        this.sharedservice.mandatorymfa.next(false);
        this.isFirmMandatoryMfa = false;
        console.log('mfaObject', mfaObject);
        this.mfaData = mfaObject ? { ...mfaObject } : null;
      } else {
        this.mfaStatus.isToggleStatus = false;
        this.mfaStatus.isToggleDisable = false;
        this.mfaStatus.isAuthEnabled = false;
      }
      // }
      if (isResetMfa) {
        console.log('isResetMfa', isResetMfa);
        this.mfaStatus.isToggleStatus = true;
        this.isToggleStatus = true;
      }

      console.log("userauthlist", this.userAuthenticatorlist);
    }, error => {
      console.log('ERROR-ERROR', error);
    });
  }

  ResetMFA() {

    let userIds: any = [];
    userIds.push(this.authService.getUserDetail().useracctid);
    const options = {
      body: {
        "userIds": userIds
      }
    }
    this.updateSpinnerConfig(true);
    this.mfaService.resetMFAbySuperAdmin(options).pipe(
      tap(resp => {
        if (resp && resp.success) {
          this.tabIndex = 3;
          this.getUserAuthList(true);
          this.toaster.success(this.mfaConstants.MFA_RESET_SUCCESS);
        }
      }),
      finalize(() => this.updateSpinnerConfig(false))
    ).subscribe(response => {
      if (response) {
        console.log(response);
      }
    });
  }

  changeToggleStatus(status: boolean) {
    console.log('Event', status);
    if (!this.isMfaEnabledForUser && this.mfaStatus.isAuthEnabled) {
      console.log("Open-Enable-MFA-DialogBox");
      this.mfaDialogBox('enableMfa');
      return;
    }
    if (this.mfaStatus.isAuthEnabled && !status) {
      console.log("Disable-MFA");
      this.mfaDialogBox('disableMfa');
      return;
    }

    this.mfaStatus.isToggleStatus = status;
  }

  setTabIndex() {
    if (this.tabIndex === 3) {
      this.tabIndex = 1;
    }
  }

  disableMfa(status: boolean) {
    this.updateSpinnerConfig(true);
    this.mfaService.disableMFA(status).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (resp) => {
        console.log('Responsepe-Disable', resp);
        this.toaster.success(this.mfaConstants.DISABLE_PERSONAL_SUCCESS);
        if (resp.success) {
          this.getUserAuthList();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.resendTimerSub.unsubscribe();
  }

  private updateSpinnerConfig(value: boolean) {
    value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
    this.spinnerConfig.update((config) => ({ ...config, isSpinShown: this.spinCount > 0 }));
  }
}

